<template>
  <component
    :is="data.url ? 'a' : 'div'"
    :href="data.url"
    class="product-carousel-media"
  >
    <div class="product-carousel-media__content">
      <div
        v-if="data.video"
        class="product-carousel-media__video-container"
      >
        <video
          :muted="videoMuted"
          class="product-carousel-media__video-player"
          :loop="data.video_loop"
          :controls="data.video_controls"
          :autoplay="data.video_autoplay"
          playsinline
        >
          <source
            v-for="(source, index) of data.video.sources"
            :key="index"
            :src="source.url"
            :type="source.type"
          >
        </video>
      </div>
      <responsive-image
        v-else
        :class="$blockClass(blockClass, 'p3roduct-carousel-media__image')"
        block-class="product-carousel-media"
        :image="data.image"
        min-max="500-2000"
        sizes="(max-width: 767px) 100vw, (min-width: 768px) calc(100vw / 4)"
        ratio="5:7"
        @responsive-image-loaded="showImage"
      />
    </div>

    <div class="product-carousel-media__footer">
      <a
        :class="{
          'product-carousel-media__footer-text': !data.url,
          'product-carousel-media__link': data.url,
        }"
        class="
        text-desktop-small-desktop
        text-mobile-small-mobile text-regular
        "
        :href="data.url"
      >
        {{ data.text }}
      </a>
    </div>
  </component>
</template>

<script>
import ResponsiveImage from '~global/images/responsive-image.vue'

export default {
  name: 'ProductCarouselMedia',

  components: {
    ResponsiveImage,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    videoMuted() {
      if (this.data.video_autoplay) {
        return true
      }

      return this.data.video_mute
    },
  },
}
</script>

<style lang="scss">
@import "./product-carousel-media";
</style>
